import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { OneFormProjectCard } from '../Project/OneFormProjectCard';
import { ProjectActionCreators } from '../../../actions';
import { DistrictDropdownOption, ProjectType } from '../../../utils/enums';

class ProbeCardVoteContainer extends Component {
	constructor(props) {
		super(props);
		this.onGoBack = this.onGoBack.bind(this);
	}

	componentDidMount() {
		let { id } = this.props.match.params;
		if (id) {
			this.props.getProject(id);
		}
	}

	onGoBack() {
		this.props.goBack();
	}

	render() {
		const {
			isAuth,
			isProjectLoading,
			isOnlyOneOffice,
			loggedUserId,
			opinionExecuting,
			voteExecuting,
			loggedUserIsCitizen,
			loggedUserOfficeId,
			loggedDistrictId,
			updateConsultationForm
		} = this.props;
		return (
			<OneFormProjectCard
				{...this.props.project}
				disabled={false}
				isAuth={isAuth}
				isOnlyOneOffice={isOnlyOneOffice}
				consultationTitle="Sonda"
				loggedUserId={loggedUserId != null ? loggedUserId : 0}
				loggedUserOfficeId={loggedUserOfficeId}
				loggedDistrictId={loggedDistrictId ? loggedDistrictId : DistrictDropdownOption.NotSetted}
				loggedUserIsCitizen={loggedUserIsCitizen}
				type={ProjectType.Probe}
				saveAnswers={updateConsultationForm}
				onCancel={this.onGoBack}
				isProjectLoading={isProjectLoading}
				opinionExecuting={opinionExecuting}
				voteExecuting={voteExecuting}
				isPreview={false}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isProjectLoading: state.project.isProjectLoading,
		opinionExecuting: state.project.opinionExecuting,
		voteExecuting: state.project.voteExecuting,
		project: state.project.project,
		loggedUserId: state.app.loggedUser.userId,
		loggedUserOfficeId: state.app.loggedUser.officeId,
		loggedDistrictId: state.app.loggedUser.districtId || DistrictDropdownOption.NotSetted,
		loggedUserIsCitizen: state.app.loggedUser.isCitizen || false
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return Object.assign({}, bindActionCreators(ProjectActionCreators, dispatch), {
		goBack: () => dispatch(goBack())
	});
};

export default connect(mapStateToProps, mapDispatchToProps)(ProbeCardVoteContainer);
